import React, { useState, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import { Form, Input, Button, Modal } from "antd";
import {
    KeyOutlined,
    UserOutlined,
    MobileOutlined,
    SafetyCertificateOutlined,
    LockOutlined,
} from "@ant-design/icons";
import { lib } from "react-single-app";
import { Send } from "./login/login";
import useRootPath from "../components/hook/useRootPath";
import { Check } from "../components/change-password";

function Forget() {
    let history = useHistory();
    let [mobile, setMobile] = useState("");
    let [password, setPassword] = useState("");
    let inviteCode = lib.getParam("inviteCode");
    const rootPath = useRootPath();
    function reset(data) {
        lib.request({
            url: "/ucenter-account/resetPwd",
            needMask: true,
            data,
            success: json => {
                Modal.success({
                    content: json.message,
                    onOk: () => history.push(`${rootPath}/login`),
                });
            },
        });
    }
    const passwordTooltip = useMemo(
        () => () => {
            return (
                <>
                    <Check
                        style={{ marginTop: "10px" }}
                        status={(() => {
                            return password.length > 7 && password.length < 21;
                        })()}>
                        密码长度为8-20位
                    </Check>
                    <Check
                        status={(function () {
                            return /^([\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]|\w)+$/.test(password);
                        })()}>
                        只能包含大小写字母、数字以及英文符号（不含空格）
                    </Check>
                    <Check
                        style={{ marginBottom: "10px" }}
                        status={(function () {
                            return (
                                /[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]+/.test(password) +
                                    /\d+/.test(password) +
                                    /[a-z]+/.test(password) +
                                    /[A-Z]+/.test(password) >
                                2
                            );
                        })()}>
                        大写字母、小写字母、数字和英文符号至少包含3种
                    </Check>
                </>
            );
        },
        [password],
    );
    return (
        <div className="forget lpr-content">
            <div className="title">
                忘记密码
                <div className="sub-title">请通过手机号找回密码</div>
            </div>

            <Form
                name="type1"
                onFinish={data => reset(data)}
                onValuesChange={(changedValues, values) => {
                    if (changedValues.hasOwnProperty("password")) {
                        setPassword(changedValues?.password);
                    }
                }}>
                <Form.Item
                    name="accountUid"
                    validateTrigger={["onBlur", "onChange"]}
                    rules={[
                        {
                            required: true,
                            message: "请输入手机号",
                        },
                        {
                            pattern: /^\d{0,11}$/,
                            message: "手机号码为1开头的11位数字",
                            validateTrigger: "onChange",
                        },
                        {
                            pattern: /^1\d{10}$/,
                            message: "手机号码为1开头的11位数字",
                            validateTrigger: "onBlur",
                        },
                    ]}>
                    <Input
                        size="large"
                        placeholder="手机号"
                        prefix={<MobileOutlined style={{ color: "#999" }} />}
                        onChange={e => setMobile(e.target.value)}
                        maxLength={11}
                    />
                </Form.Item>

                <div className="code">
                    <Form.Item
                        name="code"
                        rules={[
                            {
                                required: true,
                                message: "请输入验证码",
                            },
                            {
                                pattern: /^\d{0,6}$/,
                                message: "验证码格式错误",
                            },
                        ]}>
                        <Input
                            size="large"
                            placeholder="验证码"
                            prefix={<SafetyCertificateOutlined style={{ color: "#999" }} />}
                        />
                    </Form.Item>
                    <Send data={{ mobile, type: "RESET_PWD" }} />
                </div>
                <Form.Item
                    name="password"
                    validateTrigger={["onBlur", "onChange"]}
                    help={passwordTooltip()}
                    rules={[
                        { required: true },
                        {
                            validator: (rule, value) => {
                                return new Promise((resolve, reject) => {
                                    if (
                                        !/^([\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]|\w){8,20}$/.test(
                                            value,
                                        ) ||
                                        /[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]+/.test(value) +
                                            /\d+/.test(value) +
                                            /[a-z]+/.test(value) +
                                            /[A-Z]+/.test(value) <
                                            3
                                    ) {
                                        reject("密码格式不正确");
                                    } else {
                                        resolve();
                                    }
                                });
                            },
                            validateTrigger: "onSubmit",
                        },
                    ]}>
                    <Input.Password
                        size="large"
                        placeholder="密码"
                        prefix={<LockOutlined style={{ color: "#999" }} maxLength={20} />}
                    />
                </Form.Item>
                <Form.Item
                    name="passwordRepeat"
                    validateTrigger={["onBlur", "onChange"]}
                    rules={[
                        { required: true, message: "请输入重复密码", validateTrigger: "onChange" },
                        ({ getFieldValue }) => ({
                            validator(rule, value) {
                                if (!value || getFieldValue("password") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject("密码不一致!");
                            },
                            validateTrigger: "onBlur",
                        }),
                    ]}>
                    <Input.Password
                        size="large"
                        placeholder="重复密码"
                        prefix={<LockOutlined style={{ color: "#999" }} maxLength={20} />}
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" size="large" htmlType="submit">
                        重置密码
                    </Button>
                </Form.Item>
                <Link to={`${rootPath}/login`}>返回登录</Link>
            </Form>
        </div>
    );
}
export default Forget;
